/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationChannelListEntry
 */
export interface NotificationChannelListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    type: string;
    /**
     * 
     */
    value: boolean;
}

/**
 * Check if a given object implements the NotificationChannelListEntry interface.
 */
export function instanceOfNotificationChannelListEntry(value: object): value is NotificationChannelListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NotificationChannelListEntryFromJSON(json: any): NotificationChannelListEntry {
    return NotificationChannelListEntryFromJSONTyped(json, false);
}

export function NotificationChannelListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'value': json['value'],
    };
}

export function NotificationChannelListEntryToJSON(json: any): NotificationChannelListEntry {
    return NotificationChannelListEntryToJSONTyped(json, false);
}

export function NotificationChannelListEntryToJSONTyped(value?: NotificationChannelListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'value': value['value'],
    };
}

